import {sanitizeHtml} from '@frontapp/editor-html';

import {MailtoOptions, parseMailtoSanitized} from './mailtoHelpersCommon';

export function parseMailto(mailto: string): MailtoOptions | undefined {
  return parseMailtoSanitized(mailto, sanitizeHtml);
}
